/**
 * @generated SignedSource<<33d332179c2a013fdad3249a08bdf19e>>
 * @relayHash 33dee7298b2a429d3e7539eb86fdd08c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c43d00af2e27d63f6587cff761dbc91f14778d2b29ddc88666619ce0f14995d0

import type { ConcreteRequest } from 'relay-runtime';
export type ActivitiesFilterType = "AND" | "OR" | "%future added value";
export type ActivityFilter = {
  actors?: ReadonlyArray<string> | null | undefined;
  arguments?: ActivityFilterArgs | null | undefined;
  rootContainerIds?: ReadonlyArray<string> | null | undefined;
  type?: ActivitiesFilterType | null | undefined;
};
export type ActivityFilterArgs = {
  containerIds?: ReadonlyArray<string> | null | undefined;
  earliestStart?: AGG$DateTime | null | undefined;
  eventTypes?: ReadonlyArray<string> | null | undefined;
  latestStart?: AGG$DateTime | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
  products?: ReadonlyArray<string> | null | undefined;
  transitions?: ReadonlyArray<TransitionFilter> | null | undefined;
};
export type TransitionFilter = {
  from: string;
  to: string;
};
export type UserProfileCardEntryPointQuery$variables = {
  filter?: ActivityFilter | null | undefined;
  first: number;
  singleUserAccountId: string;
  singleUserRequestingUserId: string;
  singleUserTenantId: string;
};
export type UserProfileCardEntryPointQuery$data = {
  readonly activity: {
    readonly workedOn: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly object: {
            readonly data: {
              readonly __typename: "BitbucketPullRequest";
              readonly href: AGG$URL | null | undefined;
            } | {
              readonly __typename: "ConfluenceBlogPost";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluenceFooterComment";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluenceInlineComment";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluencePage";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluenceWhiteboard";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ExternalDocument";
              readonly url: string | null | undefined;
            } | {
              readonly __typename: "JiraIssue";
              readonly webUrl: AGG$URL | null | undefined;
            } | {
              readonly __typename: "JiraPlatformComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null | undefined;
              } | null | undefined;
              readonly webUrl: AGG$URL | null | undefined;
            } | {
              readonly __typename: "JiraServiceManagementComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null | undefined;
              } | null | undefined;
              readonly webUrl: AGG$URL | null | undefined;
            } | {
              readonly __typename: "LoomVideo";
              readonly loomUrl: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
          };
        };
      }>;
    };
  } | null | undefined;
  readonly knowledgeDiscovery: {
    readonly singleUser: {
      readonly __typename: "KnowledgeDiscoverySingleUser";
      readonly user: {
        readonly department: string | null | undefined;
        readonly email: string | null | undefined;
        readonly id: string | null | undefined;
        readonly jobTitle: string | null | undefined;
        readonly location: string | null | undefined;
        readonly manager: {
          readonly id: string | null | undefined;
          readonly jobTitle: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly organization: string | null | undefined;
        readonly picture: string | null | undefined;
        readonly thirdPartyIntegrations: ReadonlyArray<{
          readonly externalId: string;
          readonly integrationId: string;
          readonly product: string;
        }> | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type UserProfileCardEntryPointQuery = {
  response: UserProfileCardEntryPointQuery$data;
  variables: UserProfileCardEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserAccountId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserRequestingUserId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserTenantId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v11 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v7/*: any*/)
  }
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "ConfluenceInlineComment"
},
v13 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "ConfluenceFooterComment"
},
v14 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "JiraIssue"
},
v17 = [
  (v14/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v15/*: any*/)
  }
],
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDocument"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "href"
    }
  ],
  "type": "BitbucketPullRequest"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "loomUrl",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "LoomVideo"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "picture"
},
v23 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v24 = {
  "concreteType": "KnowledgeDiscoveryQueryApi",
  "kind": "LinkedField",
  "name": "knowledgeDiscovery",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "singleUserAccountId"
        },
        {
          "kind": "Variable",
          "name": "requestingUserId",
          "variableName": "singleUserRequestingUserId"
        },
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "singleUserTenantId"
        }
      ],
      "kind": "LinkedField",
      "name": "singleUser",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryUserProfile",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                (v22/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                (v23/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                },
                {
                  "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                  "kind": "LinkedField",
                  "name": "thirdPartyIntegrations",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "integrationId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "product"
                    }
                  ]
                },
                {
                  "concreteType": "KnowledgeDiscoveryUserManager",
                  "kind": "LinkedField",
                  "name": "manager",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v23/*: any*/),
                    (v22/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "KnowledgeDiscoverySingleUser"
        }
      ]
    }
  ]
},
v25 = [
  (v14/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v21/*: any*/)
    ]
  }
],
v26 = [
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v17/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v17/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v24/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              }
                            ]
                          },
                          (v21/*: any*/)
                        ]
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v24/*: any*/)
    ]
  },
  "params": {
    "id": "c43d00af2e27d63f6587cff761dbc91f14778d2b29ddc88666619ce0f14995d0",
    "metadata": {},
    "name": "UserProfileCardEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "54a78cba4743f13678610766c905f8c2";

export default node;
